import { UntypedFormGroup } from "@angular/forms";
import _ from "lodash";
import { CellChangeArg, Cellstyle, HotCell } from "~app/common/components/hot-doc/hotdoc/cell";
import { IHotDocSettings } from "~app/common/components/hot-doc/hotdoc/doc";
import { Utils } from "~app/common/services/utils";
import { Diameterklass } from "../Diameterklass";

export class RadprisNumberCell extends HotCell {
    diameterklass: Diameterklass;
    constructor(
        diameterklass: Diameterklass,
        form: UntypedFormGroup,
        protected value: number,
        flags?: Cellstyle,
        onHandle?: (newValue: CellChangeArg) => void) {

        super(flags, null, (newValue: CellChangeArg) => {
            if (newValue.newValue !== this.value) {
                this.value = newValue.rawNewValue;
                onHandle(newValue);
                this.value = newValue.newValue;
                form.markAsDirty();
                this.diameterklass.radprisDirty = true;
                newValue.complete();
            }
        });
        this.diameterklass = diameterklass;
        this.value = value;
    }

    static format(value: number): string {
        const val = _.isNumber(value) ? Math.round(value) : 0;
        return `${val.toLocaleString("en").replace(/,/g, " ")}`;
    }

    setReadOnly(): void {
        /* eslint-disable no-bitwise */
        this.flags |= Cellstyle.Readonly;
    }

    validate(value: any): boolean {
        return Utils.isNumberLike(value, true);
    }

    override onDelete(settings: IHotDocSettings): void {
        if (this.isReadonly) {
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        const changeArg = this.changeArgumentFactory(0, () => { }, settings);
        this.onChange(changeArg);
    }

    protected applyStyle(td: HTMLTableCellElement, cellProperties: any) {
        super.applyStyle(td, cellProperties);

        td.classList.add(HotCell.hotNumber);

        if (this.diameterklass.radprisDirty) {
            td.classList.add(HotCell.hotDirty);
        }
    }

    protected genHtml(): string {
        return RadprisNumberCell.format(this.value);
    }
}
